export const MAP_PAGE_ZONES: { [key: string]: string } = {
  topBanner: 'Hero',
  middleBanner: 'MerchZone',
}

export const MAP_CONTENTFUL_PAGE = 'Homepage'
